/**
 * The banner a register shows while it is a queue (wave W1, R13).
 *
 * Author: Mahmoud Ragab Ahmed.
 *
 * A queue is the register pre-filtered to what is waiting on the person. The banner says
 * so in words, with the same count Home showed, and offers the way back to the whole
 * register, so a person never mistakes a queue for "everything there is".
 */

import { ListFilter } from "lucide-react";
import { Link } from "react-router";

import { strings } from "../brand/strings";

export function QueueBanner({
  label,
  count,
  wholeRegister,
}: {
  /** The queue's name, the same words its Home card carries. */
  readonly label: string;
  /** How many records the queue holds: the same read Home counted. Null while loading. */
  readonly count: number | null;
  /** The register without the queue filter. */
  readonly wholeRegister: string;
}): React.JSX.Element {
  return (
    <div
      className="q-ui mb-(--q-s1) flex flex-wrap items-center gap-x-4 gap-y-2 rounded-md border border-gold-soft bg-gold-wash px-(--q-s0) py-(--q-s-1)"
      role="status"
      data-testid="queue-banner"
    >
      <ListFilter aria-hidden="true" className="size-4 shrink-0 text-gold" />
      <p className="min-w-0 flex-1 text-sm text-foreground">
        <strong data-testid="queue-banner-count">
          {count === null ? label : strings.queues.banner(count, label)}
        </strong>{" "}
        <span className="text-muted-foreground">{strings.queues.bannerLede}</span>
      </p>
      <Link to={wholeRegister} className="q-link text-sm" data-testid="queue-show-all">
        {strings.queues.showAll}
      </Link>
    </div>
  );
}
